import { create, el } from "@dhx/ts-common/dom";
import { Navbar, createFactory, ItemType } from "@dhx/ts-navbar";
import { IMenuElement } from "./types";

export class Menu extends Navbar<IMenuElement> {
	constructor(element?: string | HTMLElement, config?: any) {
		super(element, config);

		const render = () => this._draw();
		this.mount(element, create({ render }));
	}
	protected _getFactory() {
		return createFactory({
			widget: this,
			defaultType: ItemType.menuItem,
			allowedTypes: [
				ItemType.menuItem,
				ItemType.spacer,
				ItemType.separator,
				ItemType.customHTML,
				// TODO: deprecated
				ItemType.customHTMLButton,
			],
			widgetName: "menu-nav"
		});
	}
	private _draw(): void {
		return el("ul.dhx_widget", {
			dhx_widget_id: this._uid,
			onmousemove: this._handlers.onmousemove,
			onmouseleave: this._handlers.onmouseleave,
			onclick: this._handlers.onclick,
			onmousedown: this._handlers.onmousedown,
			class: "dhx_menu-nav " + (this.config.css ? this.config.css : "")
		}, this._drawMenuItems(this.data.getRoot(), false));
	}
}